export var Privacy = /*#__PURE__*/ function(Privacy) {
    Privacy["PrivateEphemeral"] = "private-ephemeral";
    Privacy["Public"] = "public";
    return Privacy;
}({});
export var Region = /*#__PURE__*/ function(Region) {
    Region["America"] = "us";
    Region["Germany"] = "de";
    return Region;
}({});
